module.exports = __webpack_public_path__ + "img/topimg.09e2aae5.jpg";